@if (showLabels()) {
  <ul class="product-labels">
    <!-- Brand? -->
    @if (productDetail.brandingDescription) {
      <li class="product-label">
        @if (productDetail.brandingImage) {
          <span class="product-label__icon">
            <img
              alt="{{ productDetail.brandingDescription }}"
        src="https://img.noviflora.nl/Pictures/{{
          productDetail.brandingImage
        }}"
              />
          </span>
        }
        <span class="product-label__text">{{
          productDetail.brandingDescription
        }}</span>
      </li>
    }
    <!-- New item in assortment? -->
    @if (isNew()) {
      <li class="product-label">
        <span
          class="product-label__text"
          i18n="product detail: new in assortment@@product.detail.new.in.assortment"
          >
      New in assortment
    </span>
      </li>
    }
    <!-- Auction item? -->
    @if (productDetail.vendorIsAuction) {
      <li class="product-label">
        <a href="#">
          <span
            class="product-label__text"
            i18n="product detail: auction sales@@product.detail.auction.sales"
            >
        Auction sales
      </span>
        </a>
      </li>
    }
  </ul>
}
